export default __webpack_public_path__ + "static/InHub_blueprint-100b7e8bacaafc4f335ec23ea0ef442c.mp4";